var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from 'mobx';
import { t } from 'i18next';
import { FeatureFlag, FeatureFlagManager } from '@business/feature-flags';
import Guest from './Guest';
export default class Reservation {
    constructor(serverData) {
        var _a, _b, _c, _d, _e, _f;
        Object.defineProperty(this, "accommodations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "addons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "bookingRooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "charges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "date", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "guests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "lang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nights", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentMethod", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "propertyCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "propertyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reservationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reservationStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!serverData || !serverData.success || !serverData.data) {
            this.status = false;
            this.error = (serverData === null || serverData === void 0 ? void 0 : serverData.message) || 'Unknow error';
            return;
        }
        const { data: reservation } = serverData;
        this.bookingRooms = reservation.mail_info.booking_rooms || [];
        this.status = true;
        this.propertyId = parseInt(reservation.property_id);
        this.propertyCode = reservation.property_code;
        this.date = new Date(reservation.created_at);
        this.paymentMethod = reservation.payment_method;
        this.reservationStatus = reservation.mail_info.status;
        this.reservationId = reservation.identifier;
        this.checkin = reservation.mail_info.checkin_date;
        this.checkout = reservation.mail_info.checkout_date;
        this.nights = parseInt(reservation.mail_info.nights);
        this.lang = reservation.mail_info.lang;
        const externalOrders = ((_a = reservation.mail_info.externalOrders) !== null && _a !== void 0 ? _a : []).map((order) => (Object.assign({}, order)));
        this.charges = {
            accommodations: 0,
            addons: 0,
            balanceDue: 0,
            currencyFrom: reservation.mail_info.currency_from.toLowerCase(),
            currencyRate: parseFloat(reservation.mail_info.currency_rate || '1'),
            currencyTo: reservation.mail_info.currency_to.toLowerCase(),
            deposit: 0,
            detailedTaxesAndFees: {
                data: [],
                total: 0,
            },
            externalOrders,
            grandTotal: 0,
            netTotal: 0,
            paidValue: 0,
            subtotal: 0,
            taxesAndFees: 0,
        };
        this.charges.paidValue = reservation.paid_value;
        this.charges.deposit = parseFloat(reservation.deposit);
        this.charges.balanceDue = reservation.mail_info.balance_due;
        const guest = new Guest();
        guest.firstName = reservation.mail_info.first_name;
        guest.lastName = reservation.mail_info.last_name;
        guest.email = reservation.mail_info.email;
        guest.phone = reservation.mail_info.phone;
        guest.country = reservation.mail_info.country;
        guest.city = reservation.mail_info.city;
        guest.state = reservation.mail_info.state;
        this.guests.push(guest);
        this.accommodations = [];
        const rateIdByRoomId = {};
        const roomTypeNameByRoomId = {};
        this.charges.accommodations = reservation.mail_info.rooms_total || 0;
        for (const room of reservation.mail_info.booking_rooms) {
            // @TECHDEBT: Since package_id does not exist in RawBookingInfo interface, this condition always resolves to false.
            // So accommodations are not grouped after the execution of the Reservation constructor, commenting this code
            // to keep current behavior. Review if we need the Reservation model to have the accommodations grouped.
            // const addedAccommodation = this.accommodations.find(
            //   (x) =>
            //     x.roomId === room.room_type_id &&
            //     x.packageId === room.package_id &&
            //     x.kids === room.kids &&
            //     x.adults === room.adults
            // );
            // if (addedAccommodation) {
            //   addedAccommodation.amount += 1;
            //   continue;
            // }
            const item = {
                adults: parseInt(room.adults),
                bookedId: [room.id],
                detailedRates: room.detailed_rates.map(({ adults, base_rate: baseRate, date, kids, package_rate, rate, }) => (Object.assign(Object.assign({}, (!baseRate || Number.isNaN(baseRate)
                    ? {}
                    : { baseRate: Number(baseRate) })), { adults,
                    date,
                    kids, packageRate: package_rate !== null && package_rate !== void 0 ? package_rate : rate, rate }))),
                kids: parseInt(room.kids),
                maxRoomRate: parseFloat(room.max_room_rate),
                minRoomRate: parseFloat(room.min_room_rate),
                name: room.room_type_name,
                packageId: room.package,
                // @TECHDEBT: The package_name is always translated to English when accessing the Confirmatin page directly
                packageName: room.package_name || t('standard-rate') || 'Standard Rate',
                picture: ((_c = (_b = room.room_type_photos) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.path) || '',
                price: parseFloat(room.room_total),
                quantity: 1,
                rateId: room.rate_id,
                roomId: room.room_type_id,
                smartPolicyId: room.smart_policy_id || '',
                smartPolicyRootId: room.smart_policy_root_id || '',
            };
            rateIdByRoomId[room.id] = room.rate_id;
            roomTypeNameByRoomId[room.id] = room.room_type_name;
            this.accommodations.push(item);
        }
        this.addons = [];
        // Package-included add-ons report 0.00 under mail_info.addons.totalNetPrice,
        // so the confirmation breakdown can't reconcile to the grand total. When the
        // flag is on, source the "Add-ons and Extras" line from additional_charges,
        // which the backend populates with the real add-on value.
        const sourceFromAdditionalCharges = FeatureFlagManager.isEnabled(FeatureFlag.sourceConfirmationAddonsFromAdditionalCharges);
        this.charges.addons = sourceFromAdditionalCharges
            ? (_d = reservation.mail_info.additional_charges) !== null && _d !== void 0 ? _d : reservation.mail_info.addons.totalNetPrice
            : reservation.mail_info.addons.totalNetPrice;
        for (const addon of reservation.sold_addons) {
            const accommodation = this.accommodations.find(({ bookedId }) => bookedId.includes(addon.bookingRoomId.toString()));
            if (!accommodation) {
                continue;
            }
            const item = {
                accommodationAdults: accommodation.adults,
                accommodationBookedId: addon.bookingRoomId.toString(),
                accommodationId: accommodation.roomId,
                accommodationKids: accommodation.kids,
                accommodationName: accommodation.name,
                accommodationPackageId: accommodation.packageId,
                accommodationUnit: accommodation.unit,
                addonId: addon.addonId.toString(),
                bookedId: addon.ids.map((id) => id.toString()),
                chargeType: ((addon === null || addon === void 0 ? void 0 : addon.chargeType.replaceAll('_', '-')) ||
                    'per-reservation'),
                name: addon.name,
                picture: ((_f = (_e = addon.addon_photos) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.path) || '',
                price: addon.totalPriceWithInclusive,
                quantity: addon.quantity,
                rateId: addon.addonId.toString(),
            };
            this.addons.push(item);
        }
        const taxesAndFees = Object.assign(Object.assign({}, reservation.sub_fees_grouped_by_name), reservation.sub_taxes_grouped_by_name);
        for (const key in taxesAndFees) {
            const taxOrFee = taxesAndFees[key];
            // When we receive a float value, it's comming as string, so we have to parse to have sure it will be a number
            taxOrFee.credit =
                typeof taxOrFee.credit === 'string'
                    ? parseFloat(taxOrFee.credit)
                    : taxOrFee.credit;
            this.charges.detailedTaxesAndFees.data.push(Object.assign(Object.assign({}, taxOrFee), { credit: taxOrFee.credit * (this.charges.currencyRate || 1), id: taxOrFee.tax_id }));
            this.charges.detailedTaxesAndFees.total += taxOrFee.credit;
            this.charges.taxesAndFees += taxOrFee.credit;
        }
        this.charges.netTotal =
            this.charges.accommodations +
                this.charges.addons +
                this.charges.taxesAndFees;
        this.charges.grandTotal = reservation.total;
        this.charges.subtotal = this.charges.grandTotal - this.charges.taxesAndFees;
    }
    get aggregatedAccommodations() {
        return this.accommodations.reduce((acc, room) => {
            const key = `${room.roomId}-${room.packageId}`;
            if (!acc[key]) {
                acc[key] = Object.assign(Object.assign({}, room), { quantity: 0 });
            }
            acc[key].quantity += room.quantity;
            return acc;
        }, {});
    }
    // @TECHDEBT: The return type should allow having the details for all accommodations that purchased this addon
    get aggregatedAddons() {
        return this.addons.reduce((acc, addon) => {
            const { addonId, price, quantity, rateId } = addon;
            const key = `${addonId}-${rateId}-${price}-${quantity}`;
            if (!acc[key]) {
                acc[key] = Object.assign(Object.assign({}, addon), { quantity: 0 });
            }
            acc[key].quantity += addon.quantity;
            return acc;
        }, {});
    }
    get hasAddons() {
        return this.addons.length > 0;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Reservation.prototype, "aggregatedAccommodations", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Reservation.prototype, "aggregatedAddons", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Reservation.prototype, "hasAddons", null);
